export default __webpack_public_path__ + "static/message-card-dark-f42d74f330bac50dc7a8c37f6b03499691ebbced98a7105f0f0e5f2b507001f0.png";